<i18n>
{
	"en": {
		"add": "Added",
		"remove": "Removed",
		"additionalReference": "Additional References",
		"CR": "Customers reference",
		"CU": "Consignee reference"
		
	},
	"no": {
		"add": "Laget",
		"remove": "Slettet",
		"additionalReference": "Andre Referanser",
		"CR": "Kundes referanse",
		"CU": "Mottakers referanse"
	}
}
</i18n>
<template>
	<t-vertical-panel>
		<div slot="header" class="details-header">
			<t-panel-header icon="undefined" :text="$t('additionalReference')"/>
			<div class="details-header-sub-label" v-text="$t(op)"/>
			<t-icon-button
				style="margin-right: 10px;"
				appearance="minimal"
				type="bp"
				icon="cross"
				iconSize="md"
				@click="$emit('close')"
			/>
		</div>
		<div class="content">
			<t-text-area
				class="freetext-area"
				style="width: 220px;"
				:label="name"
				minHeight="65px"
				height="65px"
				resize="vertical"
				:value="data.value"
				disabled
			/>
		</div>
	</t-vertical-panel>
</template>

<script>
export default {
	name: 'AdditionalReference',
	props: {
		data: Object,
		op: String
	},
	computed: {
		name() {
			return `${this.$t(this.data.code)} (${this.data.code})`;
		},
		value() {
			if (this.data.value) {
				return this.data.value.value;
			}
			if (this.data.oldValue) {
				return this.data.oldValue.value;
			}
			return '';
		}
	}
};
</script>
<style lang="scss" scoped>
.content {
	display: grid;
	grid-template-columns: minmax(150px, 1fr);
	column-gap: 20px;
	row-gap: 20px;
	margin: 10px;
}
.details-header {
	height: 100%;
	display:flex;
	align-items: center;
	padding-left: 5px;
	.details-header-sub-label {
		flex: 1;
		color: #66788a;
		font-size: 14px;
	}
}
</style>